import type { ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'

const TileSheet = styled(Sheet)`
  display: flex;
  align-items: center;
  inline-size: ${rem(300)};
  min-block-size: ${rem(68)};
`

export const AddedBookingTileImageFrame = styled.div`
  inline-size: ${rem(48)};
  block-size: ${rem(48)};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
  flex-shrink: 0;
`

interface Props {
  title: ReactNode
  subtitle?: string
  thumbnail?: ReactNode
}

function AddedBookingTile({ title, subtitle, thumbnail }: Props) {
  return (
    <TileSheet background="normal-background" border="light-foreground" borderRadius="L" padding={6}>
      <Group direction="horizontal" gap={8} verticalAlign="center" grow>
        {thumbnail}
        <Group direction="vertical" gap={2} grow>
          <BodyText variant="medium" weight="normal" lineClamp={1}>
            {title}
          </BodyText>
          {subtitle && <Caption variant="medium" colour="light-foreground-alt" lineClamp={1}>
            {subtitle}
          </Caption>}
        </Group>
      </Group>
    </TileSheet>
  )
}

export default AddedBookingTile
